<ng-container *ngrxLet="viewModel$; let model;">

  @if (!model.loading) {
    @if (model.params?.data?.[model.params?.colDef?.field]?.latitude && model.params?.data?.[model.params?.colDef?.field]?.longitude) {
      <a class="no-underline text-blue-40"
        [ngClass]="{'text-neutral-60': model.isFieldBlacklisted}"
        href="{{ 'https://www.google.com/maps/search/' + model.params?.value }}"
        target="_blank">
        <span>{{ model.params?.valueFormatted }}</span>
      </a>
    } @else {
      <span [ngClass]="{'text-neutral-60': model.isFieldBlacklisted}">{{model?.params?.valueFormatted}}</span>
    }
    <ng-template #span>
      <span [ngClass]="{'text-neutral-60': model.isFieldBlacklisted}">{{model?.params?.valueFormatted}}</span>
    </ng-template>
  }

  @if (model.loading) {
    <ngx-skeleton-loader
      class="w-full"
    [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
  }

</ng-container>

